import { render, staticRenderFns } from "./ListItemMortgage.vue?vue&type=template&id=0da4b2b8&scoped=true&"
import script from "./ListItemMortgage.vue?vue&type=script&lang=js&"
export * from "./ListItemMortgage.vue?vue&type=script&lang=js&"
import style0 from "./ListItemMortgage.vue?vue&type=style&index=0&id=0da4b2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da4b2b8",
  null
  
)

export default component.exports